// FOR DEV
export const SITE_CONFIG = {
    configDemo: true,
    // configApiUrl: 'https://heroapi-dev-ud7sg.ondigitalocean.app/api/'
    configApiUrl: 'http://localhost/api/'
};

// FOR PROD
// export const SITE_CONFIG = {
//     configDemo: false,
//     configApiUrl: 'https://awsapi.heroexplorer.com/api/'
// };